import React from "react";

const CodeBlock = ({ children, type = false }) => {
  return (
    <div className="inline-flex flex-col  space-x-4 rounded-lg bg-black  p-4 pl-6 text-left text-sm text-white sm:text-base">
      <div className="overflow-x-auto">
        <pre>
          {type && (
            <p className="w-fulll font-base mb-2 text-gray-inactive">{type}</p>
          )}
          {children}
        </pre>
      </div>
    </div>
  );
};

export default CodeBlock;
